<template>
  <div>
    <v-container >
      <v-card>
        <v-layout row justify-space-between>
          <v-flex xs12 md12>
            <v-card class="pa-2 mr-2" outlined v-if="!$getNoTabPermissionMessage()">
              <template
                v-if="isSetupStateLoading || isLoading || isLoadingData || featureAccessLoading"
              >
                <Loader class="mr-2 mt-6" />
              </template>
              <template v-else >
                <div>
                  <v-tabs
                    v-model="tab"
                    :centered="centered"
                    :grow="grow"
                    :vertical="vertical"
                    :right="right"
                    :prev-icon="
                      prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined
                    "
                    :next-icon="
                      nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined
                    "
                    :icons-and-text="icons"
                    show-arrows
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab v-if="$isFeatureEnabled('details')" key="details" href="#details">
                      {{ $vuetify.lang.t("$vuetify.tab.project_details_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab v-if="$isFeatureEnabled('settings') && $hasEnabledSection('settings')" key="settings" href="#settings">
                      {{ $vuetify.lang.t("$vuetify.tab.project_settings_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab v-if="$isFeatureEnabled('insights') && $hasEnabledSection('insights')" key="insights" href="#insights">
                      {{ $vuetify.lang.t("$vuetify.tab.project_insights_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab
                      v-if="$isFeatureEnabled('access') && $hasEnabledSection('access')"
                      key="access"
                      href="#access"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.tab.project_access_tab")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="$hasProjectAccessFor([$pRole.ADMIN]) &&
                        (
                          (selectedProject.segment.name === PROJECT_SEGMENTS.Maira &&
                            isGptInitialSetupCompleted) ||
                          (selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                            initialSetupDoneFunction)
                        )
                      "
                      key="emailConfig"
                      href="#emailConfig"
                    >
                      {{ $vuetify.lang.t("$vuetify.tab.email_config_tab") }}
                      <v-icon v-if="icons">mdi-email</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="$hasProjectAccessFor([$pRole.ADMIN]) &&
                        (
                          (selectedProject.segment.name === PROJECT_SEGMENTS.Maira &&
                            isGptInitialSetupCompleted) ||
                          (selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                            initialSetupDoneFunction)
                        )
                      "
                      key="broadcast"
                      href="#broadcast"
                    >

                      {{ $vuetify.lang.t("$vuetify.tab.broadcast_tab") }}
                      <v-icon v-if="icons">mdi-bullhorn</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                          $hasProjectAccessFor([$pRole.ADMIN]) &&
                          !initialSetupDoneFunction"
                      key="setup"
                      href="#setup"
                    >
                      {{ $vuetify.lang.t("$vuetify.tab.project_setup_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab
                      v-if="$isFeatureEnabled('datasets') && $hasEnabledSection('datasets') &&
                        (
                          selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                          initialSetupDoneFunction
                        )
                      "
                      key="datasets"
                      href="#datasets"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.tab.personalizer_datasets_tab")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab
                      v-if="selectedProject.segment.name === PROJECT_SEGMENTS.Maira &&
                         !isGptInitialSetupCompleted &&
                         $hasProjectAccessFor([$pRole.ADMIN])"
                      key="mairaSetup"
                      href="#mairaSetup"
                    >
                      {{ $vuetify.lang.t("$vuetify.tab.maira_setup_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="$isFeatureEnabled('maira_datasets') &&
                        ((
                          selectedProject.segment.name === PROJECT_SEGMENTS.Maira &&
                          isGptInitialSetupCompleted
                        ) ||
                        (
                          selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                          initialSetupDoneFunction
                        ))
                      "
                      key="mairaDatasets"
                      href="#mairaDatasets"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.tab.maira_datasets_tab")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="$isFeatureEnabled('maira_profiles') &&
                        ((selectedProject.segment.name ===
                          PROJECT_SEGMENTS.Maira &&
                          isGptInitialSetupCompleted) ||
                        (selectedProject.segment.name ===
                          PROJECT_SEGMENTS.PERSONALIZER &&
                          initialSetupDoneFunction))
                      "
                      key="mairaProfiles"
                      href="#mairaProfiles"
                    >
                      {{ $vuetify.lang.t("$vuetify.tab.maira_profiles_tab") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>

                    <v-tab
                      v-if="$isFeatureEnabled('maira_settings') &&
                        ((selectedProject.segment.name ===
                          PROJECT_SEGMENTS.Maira &&
                          isGptInitialSetupCompleted) ||
                        (selectedProject.segment.name ===
                          PROJECT_SEGMENTS.PERSONALIZER &&
                          initialSetupDoneFunction))
                      "
                      key="mairaSetting"
                      href="#mairaSetting"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.tab.maira_settings_tab")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <!--                    <v-tab-->
                    <!--                      class="tab-option"-->
                    <!--                      key="playground"-->
                    <!--                      href="#playground"-->
                    <!--                      v-if="selectedProject.segment.name === PROJECT_SEGMENTS.Maira || selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER">-->
                    <!--                      {{ $vuetify.lang.t("$vuetify.tab.solutions_playground_tab") }}-->
                    <!--                      <v-icon v-if="icons">mdi-phone</v-icon>-->
                    <!--                    </v-tab>-->
                    <v-tab
                      v-if="$isFeatureEnabled('design_maira') && $hasEnabledSection('design_maira') &&
                        ((selectedProject.segment.name ===
                          PROJECT_SEGMENTS.Maira &&
                          isGptInitialSetupCompleted) ||
                        (selectedProject.segment.name ===
                          PROJECT_SEGMENTS.PERSONALIZER &&
                          initialSetupDoneFunction))
                      "
                      key="designMaira"
                      href="#designMaira"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.add_maira.design_maira")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab
                      v-if="$isFeatureEnabled('ai_response') &&
                            (selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                            initialSetupDoneFunction)
                        "
                      key="aiResponse" href="#aiResponse">
                      {{ $vuetify.lang.t("$vuetify.ai_response.ai_response") }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
                    <v-tab
                      v-if="$hasProjectAccessFor([$pRole.ADMIN]) &&
                        (
                          (selectedProject.segment.name === PROJECT_SEGMENTS.Maira &&
                            isGptInitialSetupCompleted) ||
                          (selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER &&
                            initialSetupDoneFunction)
                        )
                      "
                      key="mairaQuestionnaire"
                      href="#mairaQuestionnaire"
                    >
                      {{
                        $vuetify.lang.t("$vuetify.tab.maira_questionnaire_tab")
                      }}
                      <v-icon v-if="icons">mdi-phone</v-icon>
                    </v-tab>
<!--                    <v-tab-->
<!--                      class="tab-option"-->
<!--                      key="playground"-->
<!--                      href="#playground"-->
<!--                      v-if="selectedProject.segment.name === PROJECT_SEGMENTS.Maira || selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER">-->
<!--                      {{ $vuetify.lang.t("$vuetify.solutions_playground_tab") }}-->
<!--                      <v-icon v-if="icons">mdi-phone</v-icon>-->
<!--                    </v-tab>-->
                    <v-tab-item v-if="$isFeatureEnabled('details')" key="details" value="details">
                      <ProjectDetails/>
                    </v-tab-item>
                    <v-tab-item v-if="$isFeatureEnabled('settings') && $hasEnabledSection('settings')" key="settings" value="settings">
                      <Settings
                        :fromMairaTab="fromMairaTab"
                        @reset-maira-tab-prop="fromMairaTab=false"
                      />
                    </v-tab-item>
                    <v-tab-item v-if="$isFeatureEnabled('insights') && $hasEnabledSection('insights')" key="insights" value="insights">
                      <Insights />
                    </v-tab-item>
                    <!-- <v-tab-item v-if="!initialSetupDoneFunction" key="setup" value="setup">
                          <Setup @setupCompleted="postSetupFinishAction"/>
                        </v-tab-item> -->
                    <!-- <v-tab-item  key="setup" value="setup"> -->

                    <v-tab-item key="mairaSetup" value="mairaSetup">
                      <GptSetup />
                    </v-tab-item>

                    <v-tab-item key="emailConfig" value="emailConfig">
                      <EmailConfig :project-id="selectedProject.id" />
                    </v-tab-item>

                    <v-tab-item key="broadcast" value="broadcast">
                      <GptBroadcast />
                    </v-tab-item>

                    <v-tab-item  v-if="$isFeatureEnabled('maira_datasets')" key="mairaDatasets" value="mairaDatasets">
                      <GptDatasets/>
                    </v-tab-item>
                    <v-tab-item  v-if="$isFeatureEnabled('maira_profiles')" key="mairaProfiles" value="mairaProfiles">
                      <GptProfile :tabName="tab"/>
                    </v-tab-item>
                    <v-tab-item  v-if="$isFeatureEnabled('maira_settings')" key="mairaSetting" value="mairaSetting">
                      <GptSetting :tabName="tab"/>
                    </v-tab-item>
                    <v-tab-item v-if="$isFeatureEnabled('access') && $hasEnabledSection('access')" key="access" value="access">
                      <Access :tabName="tab" />
                    </v-tab-item>
                    <v-tab-item
                      v-if="
                        selectedProject.segment.name ===
                          PROJECT_SEGMENTS.PERSONALIZER &&
                        !initialSetupDoneFunction
                      "
                      key="setup"
                      value="setup"
                    >
                      <Setup @setupCompleted="postSetupFinishAction" />
                    </v-tab-item>
                    <v-tab-item   v-if="$isFeatureEnabled('ai_response')" key="aiResponse" value="aiResponse">
                      <AiResponse />
                    </v-tab-item>
                    <v-tab-item
                      v-if="
                        $hasProjectAccessFor([$pRole.ADMIN]) &&
                        (
                          (selectedProject.segment.name === PROJECT_SEGMENTS.Maira && isGptInitialSetupCompleted) ||
                          (selectedProject.segment.name === PROJECT_SEGMENTS.PERSONALIZER && initialSetupDoneFunction)
                        )
                      "
                      key="mairaQuestionnaire"
                      value="mairaQuestionnaire"
                    >
                      <MairaQuestionnaire />
                    </v-tab-item>
                    <v-tab-item
                      v-if="$isFeatureEnabled('datasets')  && $hasEnabledSection('datasets')  &&
                        (selectedProject.segment.name ===
                        PROJECT_SEGMENTS.PERSONALIZER)
                      "
                      key="datasets"
                      value="datasets"
                    >
                      <DatasetUpdate/>
                    </v-tab-item>
                    <v-tab-item
                      class="pt-4"
                      v-if="
                        selectedProject.segment.name ===
                          PROJECT_SEGMENTS.Maira ||
                        selectedProject.segment.name ===
                          PROJECT_SEGMENTS.PERSONALIZER
                      "
                      key="playground"
                      value="playground"
                    >
                      <v-container v-show="isIframeLoading">
                        <v-row>
                          <v-col class="pt-4" cols="12">
                            <v-skeleton-loader
                              type="list-item-three-line"
                            ></v-skeleton-loader>
                          </v-col>
                        </v-row>
                      </v-container>
                      <iframe
                        :src="getIframeUrl()"
                        frameborder="0"
                        width="100%"
                        height="950px"
                        class="overflow-y-auto overflow-x-hidden"
                        @load="isIframeLoading = false"
                      ></iframe>
                    </v-tab-item>
                    <v-tab-item v-if="$isFeatureEnabled('design_maira') && $hasEnabledSection('design_maira')" key="designMaira" value="designMaira">
                      <AddMaira
                        :tab-name="tab"
                      />
                    </v-tab-item>
                  </v-tabs>
                </div>
              </template>
            </v-card>
            <v-card
              v-else
              flat
            >
              <v-row justify="center" align="center" >
                <v-col cols="12" sm="12" md="12">
                  <NoPermissionAlert :message-key="noAccessMessageKey" />
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import {
  ADD_ALERT,
  CREATE_GPT_SETTINGS,
  GET_ALL_TASKS,
  GET_GPT_DATASET_BY_ID,
  GET_GPT_DATASETS,
  GET_GPT_PROFILES,
  GET_GPT_SETTINGS,
  GET_PREVIOUSLY_SETUP_STATE,
  GET_TASK_STATUS,
  GET_TASKS_STATUS,
  LOAD_PROJECT_BY_ID,
  GET_GPT_MODELS,
  LOAD_SOLUTION_BY_ID,
  UPDATE_GPT_SETUP_STATE,
  DB_GET_TASKS_STATUS,
  DB_STORE_TASKS_STATUS,
  FETCH_DEFAULT_FEATURE_CONFIG,
} from "@/store/_actiontypes";

import {
  COMMON_TABS,
  GPT_SETUP_STEPS,
  MAIRA_TABS,
  PERSONALIZER_TABS,
  SEGMENTS,
  SEGMENTS_TAB_STORAGE_KEYS,
} from "@/global/_constants";
import ProjectDetails from "@/components/Projects/Details";
import Settings from "@/components/Projects/Settings";
import Insights from "@/components/Projects/Insights";
import AddMaira from "@/components/Projects/AddMaira";
import Setup from "@/components/Projects/Setup";
import GptSetup from "@/components/Projects/GptSetup";
import EmailConfig from "@/views/EmailConfig";
import DatasetUpdate from "@/components/Projects/DatasetUpdate";
import GptDatasets from "@/components/Projects/GptDatasets/GptDatasets";
import GptProfile from "@/components/Projects/GptProfile/GptProfile";
import GptSetting from "@/components/Projects/GptSetting/GptSetting";
import AiResponse from "@/components/Projects/AiResponse/AiResponse";
import NoPermissionAlert from "@/components/common/NoPermissionAlert.vue";
import Loader from "@/components/common/loader/Loader";
import Access from "@/views/access/Access"
import getEnv from "@/config/env";
import MairaQuestionnaire from "@/views/MairaQuestionnaire.vue";
import GptBroadcast from "@/components/Projects/GptBroadcast/GptBroadcast";
export default {
  components: {
    Loader,
    ProjectDetails,
    Settings,
    Insights,
    AddMaira,
    Setup,
    EmailConfig,
    DatasetUpdate,
    GptProfile,
    GptSetting,
    GptSetup,
    GptDatasets,
    Access,
    AiResponse,
    MairaQuestionnaire,
    GptBroadcast,
    NoPermissionAlert
  },
  data: () => ({
    tabsReady: false,
    tab: null,
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 4,
    isSetupStateLoading: false,
    isLoadingData: true,
    isIframeLoading: true,
    initialSetupDone: true,
    isLoading: false,
    PROJECT_SEGMENTS: SEGMENTS,
    datasetsProfilesFetched: false,
    gptSetupCompletedNow: false,
    fromMairaTab: false,
    gptFlowUrl: getEnv("VUE_APP_MAIRA_APP_URL"),
    res: null,
    setupTabEnforced: false,
    isGptInitialSetupCompleted:false,
    noAccessMessageKey:"$vuetify.user_access_control_permission_feature.no_access_message"
  }),
  computed: {
    ...mapState({
      user: state => state.account.user,
      selectedProject: state => state.project.selectedProject,
      gptProfiles: state => state.project.gptProfiles,
      gptDatasets: state => state.project.gptDatasets,
      gptSetupState: state => state.project.gptSetupState,
      featureAccessLoading: state => state.featureAccess.isDefaultFeatureLoading,
      isUpdateMode() {
        return !!this.gptSetupState?.dataset?.dataset_id || !!this.$route?.query?.datasetId
      },
    }),
    initialSetupDoneFunction() {
      return (
        this.selectedProject?.setup_state &&
        this.selectedProject.setup_state.every(
          entry => entry.status === "success",
        )
      );
    },
  },
  mounted() {
    this.updateGptSetupState();
  },
  beforeDestroy() {
    this.isGptInitialSetupCompleted = false;
    if(!this.isUpdateMode){
      this.$store.dispatch('project/SET_DATASET_TYPE', 'regular');
      this.$store.dispatch('project/SET_CONTENT_SOURCE', 'webUrl');
    }
  },
  created() {
    this.fetchData();
    this.fetchDefaultPermission();
  },
  watch: {
    gptSetupState: {
      handler(newVal) {
        if (newVal.completed) {
          this.isGptInitialSetupCompleted = true;
        } else {
          this.isGptInitialSetupCompleted = false;
        }
      },
      immediate: true,
      deep: true,
    },
    '$route.query.ptab': {
      handler(newTab) {
        const isMairaQuestionnaireRestricted =
          newTab === "mairaQuestionnaire" &&
          !this.$hasProjectAccessFor([this.$pRole.ADMIN]);

        const safeTab = isMairaQuestionnaireRestricted ? "details" : newTab;

        if (safeTab && safeTab !== this.tab) {
          this.tab = safeTab;
        }
      },
      immediate: true,
    },
    tab: {
      handler(newVal) {
        if (newVal) {
          if (this.$route.query.stype === 'Personalizer') {
            const storageData = localStorage.getItem(
              SEGMENTS_TAB_STORAGE_KEYS.PERSONALIZER,
            );
            if (storageData) {
              try {
                const jsonStorageData = JSON.parse(storageData);
                localStorage.setItem(
                  SEGMENTS_TAB_STORAGE_KEYS.PERSONALIZER,
                  JSON.stringify({
                    ...jsonStorageData,
                    [this.$route.query.pid]: { tab: newVal },
                  }),
                );
              } catch (e) {
                localStorage.setItem(
                  SEGMENTS_TAB_STORAGE_KEYS.PERSONALIZER,
                  JSON.stringify({
                    [this.$route.query.pid]: { tab: newVal },
                  }),
                );
              }
            } else {
              localStorage.setItem(
                SEGMENTS_TAB_STORAGE_KEYS.PERSONALIZER,
                JSON.stringify({ [this.$route.query.pid]: { tab: newVal } }),
              );
            }
          }
          else if (this.$route.query.stype === 'Maira') {
            const storageData = localStorage.getItem(
              SEGMENTS_TAB_STORAGE_KEYS.Maira,
            );
            if (storageData) {
              try {
                const jsonStorageData = JSON.parse(storageData);
                localStorage.setItem(
                  SEGMENTS_TAB_STORAGE_KEYS.Maira,
                  JSON.stringify({
                    ...jsonStorageData,
                    [this.$route.query.pid]: { tab: newVal },
                  }),
                );
              } catch (e) {
                localStorage.setItem(
                  SEGMENTS_TAB_STORAGE_KEYS.Maira,
                  JSON.stringify({
                    [this.$route.query.pid]: { tab: newVal },
                  }),
                );
              }
            } else {
              localStorage.setItem(
                SEGMENTS_TAB_STORAGE_KEYS.Maira,
                JSON.stringify({ [this.$route.query.pid]: { tab: newVal } }),
              );
            }

          }
          this.updateTabQuery(newVal);
        }
      },
      immediate: true
    },

  },
  methods: {
    ...mapActions("project", [
      LOAD_PROJECT_BY_ID,
      GET_GPT_MODELS,
      GET_PREVIOUSLY_SETUP_STATE,
      GET_GPT_PROFILES,
      GET_GPT_DATASETS,
      UPDATE_GPT_SETUP_STATE,
      GET_TASKS_STATUS,
      GET_ALL_TASKS,
      GET_GPT_SETTINGS,
      CREATE_GPT_SETTINGS,
      GET_GPT_DATASET_BY_ID,
      DB_GET_TASKS_STATUS,
      DB_STORE_TASKS_STATUS,
    ]),
    ...mapActions("task", [GET_TASK_STATUS]),
    ...mapActions("solution", [LOAD_SOLUTION_BY_ID]),
    ...mapActions("featureAccess", [FETCH_DEFAULT_FEATURE_CONFIG]),

    async fetchData() {
      try {
        this.isLoadingData = true;
        // Fetch project data
        await this.getProject();
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoadingData = false;
      }
    },
    async fetchDefaultPermission() {
      try {
        await this.getAccessControlPermission();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    updateTabQuery(newTab) {
      const currentQuery = { ...this.$route.query };
      if (currentQuery.tab === newTab) {
        // Avoid redundant navigation
        return;
      }

      this.$router.push({
        path: this.$route.path,
        query: {
          ...currentQuery,
          ptab: newTab,
        },
      }).catch(err => {
        // Ignore NavigationDuplicated error
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    updateGptSetupState() {
      this.UPDATE_GPT_SETUP_STATE({
        completed: false,
        gpt_profile: {
          completed: false,
          profile_id: null
        },
        default_profile: {
          completed: false
        },
        dataset: {
          task_id: null,
          status: null,
          dataset_id: null,
          completed: false,
        },
        training: {
          task_id: null,
          status: null,
          completed: false
        },
      });
    },
    async createDefaultProfile(profileId) {
      const gptSettingsRes = await this.GET_GPT_SETTINGS({
        project_id: this.$route.query.pid,
      });
      if (!gptSettingsRes?.data?.detail?.settings) {
        this.CREATE_GPT_SETTINGS({
          project_id: this.$route.query.pid,
          default_profile: profileId,
        }).then(res => {
        }).catch(err => {
          console.error("default profile creation error", err);
        });
      }
    },
    async getProject() {
      this.isLoading = true;
      this.isSetupStateLoading = true;
      await this.LOAD_PROJECT_BY_ID({
        project_id: this.$route.query.pid,
      }).then(
        response => {
          const project = response.data;
          this.GET_GPT_MODELS({
            project_id: this.$route.query.pid,
          });
          if (project?.segment?.name === this.PROJECT_SEGMENTS.Maira) {
            this.getGptInitialSetupState();
          } else if (
            project?.segment?.name === this.PROJECT_SEGMENTS.PERSONALIZER
          ) {
            this.getPreviouslySetupState();
          } else {
            this.isLoading = false;
            this.isSetupStateLoading = false;
          }
        },
        error => {
          this.isLoading = false;
          this.isSetupStateLoading = false;
        },
      );
    },
    async getAccessControlPermission() {
      await this.FETCH_DEFAULT_FEATURE_CONFIG();
    },

    async getGptInitialSetupState() {
      const pid = this.$route.query.pid;
      // Fetch API and DB states
      const taskAPIData = await this.GET_TASKS_STATUS({ project_id: pid });
      let dbTaskStatusData = await this.DB_GET_TASKS_STATUS({ project_id: pid });
      dbTaskStatusData = dbTaskStatusData?.data?.tasks_status;
      let taskStatus = taskAPIData;
      // Sync store or DB if either is completed
      const isApiCompleted = taskStatus?.completed === true;
      const isDbCompleted = dbTaskStatusData?.completed === true;
      const hasAccountLevelAdminAccess = this.$hasProjectAccessFor([this.$pRole.ADMIN]);
      if (isApiCompleted || isDbCompleted) {
        //TODO: handle case where either API or DB indicates completion . replace isDbCompleted with true
        this.isGptInitialSetupCompleted = true;
        const completedState = { ...taskStatus, completed: true };

        //NB: Initial level, isDbCompleted is true means isApiCompleted is completed too.
        // isApiCompleted will be false when Case 1 will happen
        // Case 1: User deleted profile or dataset from UI ,
        // then we should update the DB and Store
        if (!isApiCompleted) {
          await this.UPDATE_GPT_SETUP_STATE(completedState);
        }

        // Suppose user completed dataset,training & profile from other place,
        // Or Deleted the datasets or profiles
        // so  updated the DB always
        if (hasAccountLevelAdminAccess) {
          await this.DB_STORE_TASKS_STATUS({
            project_id: pid,
            tasks_status: completedState,
          });
        }
        taskStatus = completedState;
        dbTaskStatusData = completedState;

      } else {
        this.isGptInitialSetupCompleted = false;
        // Neither is completed, sync both to current taskStatus
        //TODO: dbTaskStatusData not execute because it is a true value object.
        // Only call after project completion as undefined
        //Need to handle nested object dataset,trainnig and profile individually
        if (!dbTaskStatusData && hasAccountLevelAdminAccess) {
          await this.DB_STORE_TASKS_STATUS({ project_id: pid, tasks_status: taskStatus });
        } else {
          taskStatus = dbTaskStatusData;
        }
        this.UPDATE_GPT_SETUP_STATE(taskStatus);
      }

      // Now do the tab logic with guaranteed updated values
      if (! taskStatus.completed) {
        this.tab = "mairaSetup";
      } else {
        const storageData = localStorage.getItem(SEGMENTS_TAB_STORAGE_KEYS.Maira);
        try {
          const jsonStorageData = JSON.parse(storageData);
          const savedTab = jsonStorageData[pid]?.tab;
          const allowedMairaTabs = this.$hasProjectAccessFor([this.$pRole.ADMIN])
            ? MAIRA_TABS
            : MAIRA_TABS.filter(tab => tab !== "mairaQuestionnaire");

          if (
            PERSONALIZER_TABS.includes(savedTab) ||
            COMMON_TABS.includes(savedTab) ||
            allowedMairaTabs.includes(savedTab)
          ) {
            this.tab = savedTab;
          } else {
            this.tab = "details";
          }
        } catch (e) {
          this.tab = "details";
        }
      }

      // Final state updates
      this.isSetupStateLoading = false;
      this.isLoading = false;
    },

    async updateGptProfile(profiles) {
      this.UPDATE_GPT_SETUP_STATE({
        ...this.gptSetupState,
        gpt_profile: { completed: true, profile_id: profiles[0]?.id },
      });
    },

    async updateGptDataset(datasets) {
      this.GET_GPT_DATASET_BY_ID({
        project_id: this.$route.query.pid,
        dataset_id: datasets[0]?.dataset_id,
      }).then(
        res => {
          if (res.data.response?.dataset?.documents_count?.total > 0) {
            this.UPDATE_GPT_SETUP_STATE({
              ...this.gptSetupState,
              dataset: { completed: true, dataset_id: datasets[0]?.dataset_id },
            });
          }
        },
        err => {
          console.error("error", err);
        },
      );
    },
    async getGPTProfiles() {
      return this.GET_GPT_PROFILES({
        project_id: this.$route.query.pid
      }).then((response) => {
        return response.data
      },
        (error) => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t("$vuetify.gpt_profile.profiles_fetch_error"),
              color: "error",
            },
            { root: true }
          );
        }
      )
    },
    async getGPTDatasets() {
      return this.GET_GPT_DATASETS({
        project_id: this.$route.query.pid
      }).then(res => {
        return res.data
      }, err => {
        console.error('err', err.response)
      })
    },
    async getAllTasks(task_type, task_status) {
      return this.GET_ALL_TASKS({
        project_id: this.$route.query.pid,
        task_type,
        task_status,
      }).then(
        res => {
          return res.data;
        },
        err => {
          console.error("err", err.response);
        },
      );
    },
    getPreviouslySetupState() {
      this.isLoading = true;
      this.isSetupStateLoading = true;
      this.GET_PREVIOUSLY_SETUP_STATE({
        project_id: this.$route.query.pid,
      }).then(
        async response => {
          const isInitialSetupDone =
            this.selectedProject?.setup_state &&
            this.selectedProject.setup_state.every(
              entry => entry.status === "success",
            );
          this.initialSetupDone = isInitialSetupDone;

          if (isInitialSetupDone !== true && this.$route.query.pid) {
            this.tab = "setup";
          } else if (this.$route.query.pid && !this.isSetupStateLoading) {
            this.tab = "settings";
          } else {
            const storageData = localStorage.getItem(
              SEGMENTS_TAB_STORAGE_KEYS.PERSONALIZER,
            );

            try {
              const jsonStorageData = JSON.parse(storageData);
              const savedTab = jsonStorageData[this.$route.query.pid]?.tab;
              if (
                PERSONALIZER_TABS.includes(savedTab) ||
                COMMON_TABS.includes(savedTab)
              ) {
                this.tab = savedTab;
              } else {
                this.tab = this.$route.query.ptab || "settings";
              }
            } catch (e) {
              // Fallback to insights if no saved tab found
              this.tab = "settings";
            }
          }
          this.isSetupStateLoading = false;
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.isSetupStateLoading = false;
        },
      );
    },
    getSolution(solution_id) {
      this.isLoading = true;
      this.LOAD_SOLUTION_BY_ID({
        solution_id: solution_id,
      }).then(
        response => { },
        error => {
          this.isLoading = false;
        },
      );
    },
    async postSetupFinishAction() {
      await this.getProject();

      // Only change tab if not already set by URL
      if (!this.$route.query.ptab) {
        this.tab = "settings";
      }
    },
    getIframeUrl() {
      let accessToken = this.user.access_token;
      let baseUrl = this.gptFlowUrl + "/";
      let queryParams = `?access_token=${accessToken}&project_id=${this.$route.query.pid}`;
      let iframeUrl = baseUrl + queryParams;
      return iframeUrl;
    },
  },
};
</script>

<style>
.tooltip {
  /* Container for our tooltip */
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  /* This is for the tooltip text */
  visibility: hidden;
  width: 100px;
  background-color: #555;
  color: white;
  text-align: center;
  padding: 1px 0;
  border-radius: 10px;
  /* This defines tooltip text position */
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  /* Makes tooltip text visible when text is hovered on */
  visibility: visible;
}

@media (max-width: 767px) {
  iframe {
    width: 100%;
    height: 850px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 20px;
  }
}

@media (min-width: 768px) and (max-width: 1029px) {
  iframe {
    width: 100%;
    height: 850px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 180px;
  }
}
</style>
